/**
 * A GROUP'S LINK — owner, 2026-10-18: Group 也可以分配給它一個特定的 URL … 使用者可以把看得到的 group 頁面直接
 * 使用 URL 的方式分享出去, 這樣其他的使用者只要登入 Avengents, 然後拿到該 URL 就可以去選擇是否要加入這個 Group.
 *
 * `/?group=<code>` — the code is the group's link code (the BFF's GROUPLINK#), never its id. Read BEFORE the
 * first render (main.tsx) and kept in this browser, because the person may not be signed in yet: the sign-in
 * round trip lands on "/" and carries nothing of ours (the BFF passes only a pairing code and an artifact
 * reference through it, on purpose). Signed in, App takes it and asks whether to join. An hour, then it is
 * forgotten: a link opened and abandoned must not spring a sheet days later.
 */
const KEY = 'avg_group_link'
const MAX_AGE_MS = 60 * 60 * 1000
const CODE = /^[0-9a-f]{16}$/

export function captureGroupLink(): void {
  try {
    const q = new URLSearchParams(window.location.search)
    const code = q.get('group')
    if (code === null) return
    if (CODE.test(code)) window.localStorage.setItem(KEY, JSON.stringify({ code, at: Date.now() }))
    q.delete('group')
    const rest = q.toString()
    window.history.replaceState(window.history.state, '', `${window.location.pathname}${rest ? `?${rest}` : ''}${window.location.hash}`)
  } catch {
    /* no storage (private window): the link opens nothing, and the address is left as it was */
  }
}

/** The link this browser was opened with, once — then it is gone. */
export function takeGroupLink(): string | null {
  try {
    const raw = window.localStorage.getItem(KEY)
    window.localStorage.removeItem(KEY)
    if (!raw) return null
    const { code, at } = JSON.parse(raw) as { code?: unknown; at?: unknown }
    if (typeof code !== 'string' || !CODE.test(code)) return null
    if (typeof at !== 'number' || Date.now() - at > MAX_AGE_MS) return null
    return code
  } catch {
    return null
  }
}

/** The address to pass on. The app's own origin — inside the iOS/Android shell that is still the site's. */
export function groupLinkUrl(code: string): string {
  const origin = /^https:\/\//.test(window.location.origin) ? window.location.origin : 'https://app.avengents.ai'
  return `${origin}/?group=${code}`
}
